__turbopack_context__.v({
  "author": "Testimonials-module__dXzQNa__author",
  "authorInfo": "Testimonials-module__dXzQNa__authorInfo",
  "authorName": "Testimonials-module__dXzQNa__authorName",
  "authorRole": "Testimonials-module__dXzQNa__authorRole",
  "avatar": "Testimonials-module__dXzQNa__avatar",
  "avatarsGroup": "Testimonials-module__dXzQNa__avatarsGroup",
  "card": "Testimonials-module__dXzQNa__card",
  "container": "Testimonials-module__dXzQNa__container",
  "content": "Testimonials-module__dXzQNa__content",
  "grid": "Testimonials-module__dXzQNa__grid",
  "header": "Testimonials-module__dXzQNa__header",
  "quoteText": "Testimonials-module__dXzQNa__quoteText",
  "quoteWatermark": "Testimonials-module__dXzQNa__quoteWatermark",
  "section": "Testimonials-module__dXzQNa__section",
  "stars": "Testimonials-module__dXzQNa__stars",
  "trustFooter": "Testimonials-module__dXzQNa__trustFooter",
});
